import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

function getElectronicCommercialInvoice(row: FulfillmentGroupData): string {
  const summary = row.shipmentSummary;
  const invoiceShipment = summary?.carrierShipments.find(
    (cs) => cs.commercialInvoiceUrl,
  );
  if (!invoiceShipment) {
    return "N/A";
  }

  return invoiceShipment.comInvoiceSubmittedElectronically ? "true" : "false";
}

export const CommercialInvoiceSubmittedElectronicallyCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Comm. invoice e-submitted",
    cell: (row) => {
      return getElectronicCommercialInvoice(row);
    },
  };
